// extracted by mini-css-extract-plugin
module.exports = {"button":"dece2e673c--button--Va282","icon":"dece2e673c--icon--sqsbY"};